<template>
  <div>
    <el-form label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$l('form_label_shipmentNo') || '发运单号'">
            <el-input :value="detail.shipmentNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_planNos') || '补货计划编号'">
            <el-input :value="detail.planNos" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_transportNos') || '外运编号'">
            <el-input :value="detail.transportNos" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_totalGoodsQty') || '产品总数量'">
            <el-input :value="detail.totalGoodsQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_totalCtnQty') || '总箱数'">
            <el-input :value="detail.totalCtnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_totalGrossWeight') || '总毛重(kg)'"
          >
            <el-input :value="detail.totalGrossWeight" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_totalNetWeight') || '总净重(kg)'"
          >
            <el-input :value="detail.totalNetWeight" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_totalVolume') || '总体积(m³)'">
            <el-input :value="detail.totalVolume" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('form_label_totalBookingVolumeSummary') || '总订舱体积(m³)'
            "
          >
            <el-input :value="detail.totalBookingVolume" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_costAmount') || '成本金额'">
            <el-input :value="totalCostAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_salesAmount') || '销售金额'">
            <el-input :value="totalSalesAmount" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    detail: { type: Object, default: () => ({}) },
  },
  computed: {
    totalCostAmount() {
      const {
        totalCostAmount,
        costCurrencyUnit,
        costCurrencyUnitName,
      } = this.detail
      return [totalCostAmount || '0', costCurrencyUnitName || costCurrencyUnit]
        .filter(Boolean)
        .join(' ')
    },
    totalSalesAmount() {
      const {
        totalSalesAmount,
        salesCurrencyUnit,
        salesCurrencyUnitName,
      } = this.detail

      return [
        totalSalesAmount || '0',
        salesCurrencyUnitName || salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
  },
}
</script>
